import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import {isEmpty} from '../../../helpers/utils'

import questionHandlers from './question-handlers'
import {createPost} from '../../../helpers/command'
import {toDisplayPoints} from '../../../helpers/utils'

const useStyles = makeStyles(questionStyles)
 
export default function Question ({assessment, question, section, sections, context, questionIndex}) {

  const {id: questionId, sectionId} = question
  const {translate, quizQuestionTypes} = context

  const classes = useStyles()

  const globalIndex = section.sectionStarts + questionIndex

  const count = sections.reduce((a, b) => a + b.questions.length, 0)

  const {html} = question && question.premise || {}

  const premiseHtml = isEmpty(html) ? false : html

  const type = quizQuestionTypes.find(t => t.id == question.type) || {}

  const title = translate(type.name)

  const indexLabel = `${globalIndex + 1}`

  const Handler = questionHandlers[type.name]

  const defaultPremiseLabel = `${type.name}-default-premise`
  const defaultPremise = translate(defaultPremiseLabel)
  const hasDefaultPremise = defaultPremiseLabel != defaultPremise
  const handlerAsPremise = !premiseHtml && !hasDefaultPremise

  return (
    <Box key={question.id} className={classes.root}>
      <Box className={classes.header}>
        <Box className={classes.title}>
          <span className={classes.index}>{indexLabel}.</span>
          {premiseHtml && <span className={classes.premise} dangerouslySetInnerHTML={{__html: premiseHtml}} />}
          {!premiseHtml && hasDefaultPremise && <span className={classes.premise}>{defaultPremise}</span>}
          {handlerAsPremise && Handler && <Handler {...{assessment, context, question, section, questionIndex}} />}
        </Box>
      </Box>
      {!handlerAsPremise && Handler && (
      <Box className={classes.content}>
        <Box className={classes.question}>
          {Handler && <Handler {...{assessment, context, question, section, questionIndex}} />}
        </Box>
      </Box>)}
    </Box>
  )
}

function questionStyles(theme) {

  const verticalCentering = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  }

  return {
    root: {
      flexGrow: 1,
      display: 'flex',
      marginTop: 50,
      flexDirection: 'column',
      color: '#000',
    },
    header: {
      display: 'flex',
      fontSize: '11pt',
      fontWeight: 600,
      padding: 0,
    },
    question: {
      display: 'flex',
      flexGrow: 1,
      paddingLeft: 15
    },
    title: {
      flexGrow: 1,
      fontSize: '1rem',
      display: 'flex'
    },
    index: {
      marginRight: 5,
      ...verticalCentering
    },
    content: {
      flexGrow: 1,
      overflowY: 'auto',
      padding: 15,
      display: 'flex',
      flexDirection: 'column',
    },
  }
}

